<template>
  <page>
    <div :load="doInit">
      <v-expansion-panels v-model="panel1" multiple>
        <v-expansion-panel>
        <v-expansion-panel-header>
          <div>
            <v-icon>mdi-settings</v-icon> Type of Reports
          </div>
        </v-expansion-panel-header>
          <v-expansion-panel-content>
          <v-card>
            <v-card-text>
              <v-form>
                <v-container fluid grid-list-sm>
                  <v-layout row wrap>
                    <v-flex xs12 md6 >
                      <v-autocomplete :items="typeReportList" v-model="reportForm.reportType" :label="labels.reportType" item-text="label" item-value="value" data-vv-name="reportType" :data-vv-as="labels.reportType" :error-messages="errors.collect('reportType')" @change="doDisplayTrans"></v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-expansion-panels v-model="panel2" multiple>
        <v-expansion-panel>
        <v-expansion-panel-header>
          <div>
            <v-icon>mdi-calendar-range</v-icon> Date Ranges
          </div>
        </v-expansion-panel-header>
          <v-expansion-panel-content>
          <v-card>
            <v-card-text>
              <v-form>
                <v-container fluid grid-list-sm>
                  <v-layout row wrap>
                    <v-flex xs6>
                      <cal-picker v-model="reportForm.tranDateFrom" :label="labels.tranDateFrom" v-validate="fromDateValidation(reportForm.tranDateFrom)" :data-vv-as="labels.tranDateFrom" data-vv-name="tranDateFrom" :error-messages="errors.collect('tranDateFrom')" :min="fromDateMinDate" :max="fromDateMax()"></cal-picker>
                    </v-flex>
                    <v-flex xs6>
                      <cal-picker v-model="reportForm.tranDateTo" :label="labels.tranDateTo" v-validate="toDateValidation(reportForm.tranDateTo)" :data-vv-as="labels.tranDateTo" data-vv-name="tranDateTo" :error-messages="errors.collect('tranDateTo')" :max="fromDateMax()"></cal-picker>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-expansion-panels v-model="panel3" multiple>
        <v-expansion-panel>
        <v-expansion-panel-header>
          <div>
            <v-icon>mdi-filter-variant</v-icon> Filters
          </div>
        </v-expansion-panel-header>
          <v-expansion-panel-content>
          <v-card>
            <v-card-text>
              <v-form>
                <v-container fluid grid-list-sm>
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg6>
                      <v-text-field v-model="reportForm.polType" :label="labels.polType" :error-messages="errors.collect('polType')" data-vv-name="polType" :data-vv-as="labels.polType" append-icon="mdi-magnify" v-validate="'required'" @click:append="getHelpList('polType')" readonly clearable></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 lg6>
                      <v-text-field v-model="reportForm.busCls" :label="labels.busCls" :error-messages="errors.collect('busCls')" data-vv-name="busCls" :data-vv-as="labels.busCls" append-icon="mdi-magnify" @click:append="getHelpList('busCls')" readonly clearable></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-expansion-panels v-model="panel4" multiple>
        <v-expansion-panel>
        <v-expansion-panel-header>
          <div>
            <v-icon>mdi-settings</v-icon> XOL Layers
          </div>
        </v-expansion-panel-header>
          <v-expansion-panel-content>
          <v-card>
            <v-card-text>
              <v-form>
                <v-container fluid grid-list-sm>
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg6>
                      <v-text-field v-model="reportForm.facXOL" :label="labels.facXOL" :error-messages="errors.collect('facXOL')" data-vv-name="facXOL" :data-vv-as="labels.facXOL" clearable></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 lg6>
                      <v-text-field v-model="reportForm.facXOLPct" :label="labels.facXOLPct" :error-messages="errors.collect('facXOLPct')" data-vv-name="facXOLPct" :data-vv-as="labels.facXOLPct" v-validate="'entry|mask_min_value:0.00|mask_decimal:2'" clearable></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg6>
                      <v-text-field v-model="reportForm.xolLayer1" :label="labels.xolLayer1" :error-messages="errors.collect('xolLayer1')" data-vv-name="xolLayer1" :data-vv-as="labels.xolLayer1" clearable></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 lg6>
                      <v-text-field v-model="reportForm.xolLayer1Pct" :label="labels.xolLayer1Pct" :error-messages="errors.collect('xolLayer1Pct')" data-vv-name="xolLayer1Pct" :data-vv-as="labels.xolLayer1Pct" v-validate="'entry|mask_min_value:0.00|mask_decimal:2'" clearable></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg6>
                      <v-text-field v-model="reportForm.xolLayer2" :label="labels.xolLayer2" :error-messages="errors.collect('xolLayer2')" data-vv-name="xolLayer2" :data-vv-as="labels.xolLayer2" clearable></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 lg6>
                      <v-text-field v-model="reportForm.xolLayer2Pct" :label="labels.xolLayer2Pct" :error-messages="errors.collect('xolLayer2Pct')" data-vv-name="xolLayer2Pct" :data-vv-as="labels.xolLayer2Pct" v-validate="'entry|mask_min_value:0.00|mask_decimal:2'" clearable></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg6>
                      <v-text-field v-model="reportForm.xolLayer3" :label="labels.xolLayer3" :error-messages="errors.collect('xolLayer3')" data-vv-name="xolLayer3" :data-vv-as="labels.xolLayer3" clearable></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 lg6>
                      <v-text-field v-model="reportForm.xolLayer3Pct" :label="labels.xolLayer3Pct" :error-messages="errors.collect('xolLayer3Pct')" data-vv-name="xolLayer3Pct" :data-vv-as="labels.xolLayer3Pct" v-validate="'entry|mask_min_value:0.00|mask_decimal:2'" clearable></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg6>
                      <v-text-field v-model="reportForm.xolLayer4" :label="labels.xolLayer4" :error-messages="errors.collect('xolLayer4')" data-vv-name="xolLayer4" :data-vv-as="labels.xolLayer4" clearable></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 lg6>
                      <v-text-field v-model="reportForm.xolLayer4Pct" :label="labels.xolLayer4Pct" :error-messages="errors.collect('xolLayer4Pct')" data-vv-name="xolLayer4Pct" :data-vv-as="labels.xolLayer4Pct" v-validate="'entry|mask_min_value:0.00|mask_decimal:2'" clearable></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg6>
                      <v-text-field v-model="reportForm.surplus" :label="labels.surplus" :error-messages="errors.collect('surplus')" data-vv-name="surplus" :data-vv-as="labels.surplus" v-validate="'entry|mask_min_value:0.00|mask_decimal:2'" clearable></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg6>
                      <v-text-field v-model="reportForm.treatyComm" :label="labels.treatyComm" :error-messages="errors.collect('treatyComm')" data-vv-name="treatyComm" :data-vv-as="labels.treatyComm" v-validate="'entry|mask_min_value:0.00|mask_decimal:2'" clearable></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg6>
                      <v-text-field v-model="reportForm.brokerage" :label="labels.brokerage" :error-messages="errors.collect('brokerage')" data-vv-name="brokerage" :data-vv-as="labels.brokerage" v-validate="'entry|mask_min_value:0.00|mask_decimal:2'" clearable></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg6>
                      <v-text-field v-model="reportForm.marineQSPrem" :label="labels.marineQSPrem" :error-messages="errors.collect('marineQSPrem')" data-vv-name="marineQSPrem" :data-vv-as="labels.marineQSPrem" v-validate="'entry|mask_min_value:0.00|mask_decimal:2'" clearable></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12 md6 lg6>
                      <v-text-field v-model="reportForm.marineQSComm" :label="labels.marineQSComm" :error-messages="errors.collect('marineQSComm')" data-vv-name="marineQSComm" :data-vv-as="labels.marineQSComm" v-validate="'entry|mask_min_value:0.00|mask_decimal:2'" clearable></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      <v-spacer class="mt-2"></v-spacer>
      <v-container fluid grid-list-sm>
        <v-layout row wrap>
          <v-flex lg12 xs12>
            <v-checkbox dense v-model="reportForm.printRptRunTime" :label="labels.printRptRunTime" data-vv-name="printRptRunTime" :data-vv-as="labels.printRptRunTime"></v-checkbox>
          </v-flex>
          <v-flex lg6 xs12>
            <v-btn class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
              <v-icon left dark>mdi-file-export</v-icon>
              {{labels.export}}
            </v-btn>
            <v-btn-toggle dense mandatory v-model="reportForm.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
            </v-btn-toggle>
          </v-flex>
        </v-layout>
      </v-container>
       <v-dialog v-model="polTypeHelplist" width="900px" persistent>
        <GAXPMultiPolTypeHelplist :menu="menu" :reportType="reportForm.reportType" @close="doClose" @doAssign="doAssignPolType($event)"></GAXPMultiPolTypeHelplist>
      </v-dialog>
      <v-dialog v-model="busClsHelplist" width="900px" persistent>
        <GAXPMultiBusClsHelplist :menu="menu" :reportType="reportForm.reportType" :polType="reportForm.polType" @close="doClose" @doAssign="doAssignBusCls($event)"></GAXPMultiBusClsHelplist>
      </v-dialog>
    </div>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import GAXPMultiPolTypeHelplist from './GAXPMultiPolTypeHelplist'
import GAXPMultiBusClsHelplist from './GAXPMultiBusClsHelplist'
import { checkDateRangeFrom, checkDateRangeTo } from './index'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      labels: {
        reportType: 'Report',
        dateRange: 'Date Ranges',
        tranDateFrom: 'Transaction Date From',
        tranDateTo: 'To',
        polType: 'Policy Type',
        busCls: 'Business Class',
        facXOL: 'FacXOL',
        facXOLPct: '%',
        xolLayer1: 'XOL Layer 1',
        xolLayer1Pct: '%',
        xolLayer2: 'XOL Layer 2',
        xolLayer2Pct: '%',
        xolLayer3: 'XOL Layer 3',
        xolLayer3Pct: '%',
        xolLayer4: 'XOL Layer 4',
        xolLayer4Pct: '%',
        surplus: 'Surplus %',
        treatyComm: 'Treaty Comm %',
        brokerage: 'Brokerage (only for Fire)',
        marineQSPrem: 'Marine Q/s Prem %',
        marineQSComm: 'Marine Q/s Comm %',
        format: 'Export Format',
        export: 'Export to',
        printRptRunTime: 'Print Runtime Parameters'
      },
      reportForm: {
        reportType: undefined,
        tranDateFrom: undefined,
        tranDateTo: new Date(),
        polType: undefined,
        busCls: undefined,
        facXOL: undefined,
        facXOLPct: 0,
        xolLayer1: undefined,
        xolLayer2: undefined,
        xolLayer3: undefined,
        xolLayer4: undefined,
        xolLayer1Pct: 0,
        xolLayer2Pct: 0,
        xolLayer3Pct: 0,
        xolLayer4Pct: 0,
        surplus: 0,
        treatyComm: 0,
        brokerage: 0,
        marineQSPrem: 0,
        marineQSComm: 0,
        format: undefined,
        printRptRunTime: true
      },
      // HelpList
      polTypeHelplist: false,
      busClsHelplist: false,
      // Other
      riTypeList: [],
      today: new Date(),
      fromDateMinDate: new Date(2000, 0, 1),
      menu: {},
      supportedFormat: [],
      loading: false,
      typeReportList: [
        { value: '2', label: 'Combined Accident XOL' },
        { value: '1', label: 'Fire XOL' },
        { value: '5', label: 'Engineering XOL' },
        { value: '4', label: 'Marine XOL' },
        { value: '3', label: 'Miscellaneous Accident XOL' }
      ],
      panel1: [0],
      panel2: [0],
      panel3: [0],
      panel4: [0]
    }
  },
  watch: {
    'reportForm.reportType': function() {
      this.reportForm.polType = ''
      this.reportForm.busCls = ''
      this.reportForm.facXOL = ''
      this.reportForm.xolLayer1 = ''
      this.reportForm.xolLayer2 = ''
      this.reportForm.xolLayer3 = ''
      this.reportForm.xolLayer4 = ''
    }
  },
  computed: {
    riMenu() {
      return this.$store.state.reports.riReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    getHelpList(value) {
      if (value === 'polType') {
        this.polTypeHelplist = true
      } else if (value === 'busCls') {
        this.busClsHelplist = true
      }
    },
    async doInit() {
      try {
        if (this.$store.state.reports.riReports.init !== 1) {
          await this.$store.dispatch('riReportsInit')
        }
        const apiURI = this.riMenu.gnpiAndXolPremiums
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doClose() {
      this.polTypeHelplist = false
      this.busClsHelplist = false
    },
    doAssignPolType(obj) {
      this.reportForm.polType = ''
      this.reportForm.polType = obj.finalSelectedItems.toString()
      this.polTypeHelplist = false
    },
    doAssignBusCls(obj) {
      this.reportForm.busCls = ''
      this.reportForm.busCls = obj.finalSelectedItems.toString()
      this.busClsHelplist = false
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async fetchXOLLayers() {
      const apiURI = this.menu.xolLayers
      const expand = {
        reportType: this.reportForm.reportType,
        polType: this.reportForm.polType,
        busCls: this.reportForm.busCls,
        tranDateFrom: this.reportForm.tranDateFrom,
        tranDateTo: this.reportForm.tranDateTo
      }
      if (apiURI) {
        this.loading = true
        this.$http.get(expandURI(apiURI, expand)).then(result => {
          let items = []
          const { dataList } = result.data
          if (dataList) {
            dataList.map(xolLayers => {
              items.push(xolLayers.value)
            })
          }
          this.reportForm.xolLayers = items.toString()
          this.loading = false
        }).catch(err => {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      }
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        try {
          this.loading = true
          const layers = ['polType', 'busCls', 'facXOLPct', 'xolLayer1Pct', 'xolLayer2Pct', 'xolLayer3Pct', 'xolLayer4Pct', 'surplus', 'treatyComm', 'brokerage', 'marineQSPrem', 'marineQSComm']
          layers.forEach(layer => {
            if (this.reportForm[layer] === null || this.reportForm[layer] === undefined || this.reportForm[layer] === '') {
              if (layer === 'polType' || layer === 'busCls') {
                this.reportForm[layer] = 'All'
              } else {
                this.reportForm[layer] = 0
              }
            }
          })
          await this.$http.post(apiURI, this.reportForm)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doDisplayTrans() {
      if (this.reportForm.reportType === 'S') {
        this.reportForm.displayTrans = false
      }
    },
    fromDateMax() {
      if (this.reportForm.toDate1) {
        return this.reportForm.toDate1
      } else {
        return new Date(2070, 11, 31)
      }
    },
    fromDateValidation(toDate1) {
      if (toDate1) {
        return 'required|checkDateRangeFrom:' + toDate1
      } else {
        return 'required|checkDateRangeFrom'
      }
    },
    toDateValidation(fromDate1) {
      if (fromDate1) {
        return 'required|checkDateRangeTo:' + fromDate1
      } else {
        return 'required|checkDateRangeTo'
      }
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('checkDateRangeFrom', checkDateRangeFrom)
    this.$validator.extend('checkDateRangeTo', checkDateRangeTo)
  },
  mixins: [
    MessageMixin
  ],
  components: {
    GAXPMultiPolTypeHelplist,
    GAXPMultiBusClsHelplist
  }
}
</script>
